import { useAtomValue, useSetAtom } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';
import { fetchKPIRequests } from '../../../../../../services/queries/KPIRequestsQueries';
import { kpisRequestsListStateJ } from '../../../../../../services/state/KPI/KPIRequestsStateJ';
import { clientConfigFieldsAtom } from '../../../../../../services/state/AppConfigStateJ';
import { MaggieFeatureFlags } from '../../../../../../util/feature-flags';

/**
 * No-ops for consolidated V2 clients -- request lifecycle has moved to
 * Starbreaker, so Maggie's KpiRequest cache is never read for them.
 */
export function useInvalidateKPIRequests() {
  const setRequests = useSetAtom(kpisRequestsListStateJ);
  const isConsolidated =
    (useAtomValue(clientConfigFieldsAtom)?.Using_Consolidated_Data_Collection as boolean) ?? false;
  const { useStarbreakerCollectionV2 } = useFlags<MaggieFeatureFlags>();
  const isConsolidatedV2 = isConsolidated && useStarbreakerCollectionV2;

  return useCallback(async () => {
    if (isConsolidatedV2) {
      return;
    }
    setRequests(await fetchKPIRequests());
  }, [isConsolidatedV2, setRequests]);
}
